<template>
    <div>

    </div>

</template>

<script>
    export default {
        name: "toast",
        data() {
            return {
                toastCount: 0,
                string_err : 'IMC ERR',
                string_title : 'IMC_ERR TITLE',
                variant : 'success'
            }
        },

        created () {
            EventBus.$on('show_toast', e => {
                console.log(e);
                if(e !== undefined) {
                    this.string_err       = e.err;
                    this.string_title     = e.title;
                    if(e.type !== undefined) {
                        this.variant = e.type;
                    }
                    this.makeToast();
                }


            });
        },
        methods : {
            makeToast(append = false) {
                this.toastCount++;
                this.$bvToast.toast(this.string_err, {
                    title: this.string_title,
                    autoHideDelay: 50000,
                    appendToast: true,
                    variant: this.variant,
                    solid:true
                })
            }
        }
    }
</script>

<style scoped>

</style>
